import { Component, Input } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";
import { AppLayoutComponent } from "../../../../shared/components/app-layout/app-layout.component";
import { PageHeaderComponent } from "../../../../shared/components/page-header/page-header.component";
import { EventFormComponent } from "../event-form/event-form.component";

@Component({
  selector: "app-edit-event-container",
  imports: [
    AppLayoutComponent,
    MatDialogModule,
    EventFormComponent,
    PageHeaderComponent,
  ],
  templateUrl: "./edit-event-container.component.html",
  styleUrl: "./edit-event-container.component.scss",
})
export class EditEventContainerComponent {
  @Input() id: string | null = null;
}
